import React from 'react'
import { clsx } from 'clsx'

const variantStyles = {
  primary: {
    background: 'rgba(31,159,147,.12)',
    color: '#167e75',
    borderColor: 'rgba(31,159,147,.18)',
  },
  secondary: {
    background: 'var(--color-badge-secondary-bg)',
    color: 'var(--color-badge-secondary-text)',
    borderColor: 'var(--color-badge-secondary-border)',
  },
  success: {
    background: 'var(--color-success-bg)',
    color: 'var(--color-success-text)',
    borderColor: 'var(--color-success-border)',
  },
  warning: {
    background: 'var(--color-warning-bg)',
    color: 'var(--color-warning-text)',
    borderColor: 'var(--color-warning-border)',
  },
  error: {
    background: 'var(--color-error-bg)',
    color: 'var(--color-error-text)',
    borderColor: 'var(--color-error-border)',
  },
  gray: {
    background: 'var(--color-badge-gray-bg)',
    color: 'var(--color-badge-gray-text)',
    borderColor: 'var(--color-badge-gray-border)',
  },
}

const sizeStyles = {
  xs: { padding: '4px 6px', fontSize: '10px' },
  sm: { padding: '6px 8px', fontSize: '11px' },
  md: { padding: '8px 10px', fontSize: '12px' },
  lg: { padding: '10px 14px', fontSize: '13px' },
}

const Badge = ({
  children,
  variant = 'secondary',
  size = 'md',
  className = '',
  ...props
}) => {
  const vStyle = variantStyles[variant] || variantStyles.secondary
  const sStyle = sizeStyles[size] || sizeStyles.md

  return (
    <span
      className={clsx('inline-flex items-center gap-2 rounded-xl font-black select-none', className)}
      style={{
        ...vStyle,
        ...sStyle,
        border: `1px solid ${vStyle.borderColor}`,
      }}
      {...props}
    >
      {children}
    </span>
  )
}

export default Badge
